import { render, staticRenderFns } from "./InfoProdutoNoCarrinho.vue?vue&type=template&id=47f25688&scoped=true"
import script from "./InfoProdutoNoCarrinho.vue?vue&type=script&lang=js"
export * from "./InfoProdutoNoCarrinho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f25688",
  null
  
)

export default component.exports